function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.4
}, /*#__PURE__*/React.createElement(Path, {
  strokeWidth: 1.5,
  d: "M17.186 9.597a8.09 8.09 0 10-16.18.003 8.09 8.09 0 0016.18-.004z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeWidth: 1.5,
  d: "M13.9 10.686a6 6 0 10-12 0 6 6 0 0012 0zm12.161-9.178H9.097m16.964 16.178H9.097m16.964 1.354h2.261v-2.709h-2.261zm2.618 1.12l-.357-.52v-3.909l.357-.52c.357-.522.95-.835 1.583-.835h5.99v6.619h-5.99a1.916 1.916 0 01-1.583-.835zm7.675 0h3.25v-4.949h-3.25z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeWidth: 0.75,
  d: "M39.604 16.563h-3.25m3.25 2.239h-3.25"
}));

function SvgIconMenuHdmi(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 22
  }, props), _ref);
}

export default SvgIconMenuHdmi;